module.exports = __webpack_public_path__ + "img/1311.0cebd421.gif";